import React from 'react';
import { usePleriStatus } from './hooks';

interface PleriStatusGateProps {
  children: React.ReactNode;
  invert?: boolean;
}

export const PleriStatusGate: React.FC<PleriStatusGateProps> = ({
  children,
  invert = false,
}) => {
  const { data: pleriStatus, isLoading } = usePleriStatus();

  if (isLoading) {
    return null;
  }

  const isEnabled =
    !!pleriStatus?.isEnabled && !!pleriStatus?.showPleriInDashboard;
  if (invert ? isEnabled : !isEnabled) {
    return null;
  }

  return <>{children}</>;
};
